// src/components/TitleLoader.js
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import {fetchDateActivityInfo} from "../api/dateActivityInfoApi";

const TitleLoader = () => {
    const [title, setTitle] = useState("數位商務大趨勢 | 國際匯壇");

    useEffect(() => {
        fetchDateActivityInfo().then(data => {
            setTitle(data.siteName);
        }).catch(error => {
            console.error("Error fetching title data:", error);
        });
    }, []);

    return (
        <Helmet>
            <title>{title}</title>
        </Helmet>
    );
};

export default TitleLoader;
